/**
 * RecoveryRoute — guard для /reset-password.
 *
 * Эта страница обрабатывает клик по ссылке из письма. В момент загрузки
 * у юзера может быть:
 * - Активная recovery-сессия (supabase-js распарсил токен из URL hash) —
 *   нужно пропустить, чтобы ResetPasswordPage мог вызвать updateUser.
 * - Нет сессии вообще (ссылка просрочена / открыли напрямую) —
 *   тоже пропускаем, ResetPasswordPage сам покажет экран "ссылка недействительна".
 *
 * То есть эта страница доступна всем без ограничений — в отличие от
 * PublicOnlyRoute (который блокирует залогиненных) и ProtectedRoute
 * (который блокирует неавторизованных).
 *
 * Сам компонент простой, но вынесен отдельно ради семантической ясности
 * в роутере: видно почему /reset-password обёрнут иначе, чем остальные
 * auth-страницы.
 */

import { Outlet } from 'react-router';

export function RecoveryRoute(): JSX.Element {
  return <Outlet />;
}
